import React, { FC } from 'react';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks/DataService';
import { chargingMethodService, countryService, currencyService } from '../../../../../channels/secure-web/services';
import { Currency } from '../../domain/Currency/entities';
import { Country } from '../../domain/Country/entities';
import { ChargingMethod } from '../../domain/ChargingMethod/entities';
import { FundTransferContext } from './FundTransferContext';

const FundTransferProvider: FC = ({ children }) => {
  // Define api calls
  const {
    data: currenciesData,
    error: currenciesError,
    isLoading: isLoadingCurrencies,
  } = useInvokeSWRService<Currency[]>(currencyService.GetCurrencies, {}, true, 'currencyService.GetCurrencies');

  const {
    data: countriesData,
    error: countriesError,
    isLoading: isLoadingCountries,
  } = useInvokeSWRService<Country[]>(countryService.GetCountries, {}, true, 'countryService.GetCountries');

  const {
    data: chargingMethodsData,
    error: chargingMethodsError,
    isLoading: isLoadingChargingMethod,
  } = useInvokeSWRService<ChargingMethod[]>(
    chargingMethodService.GetChargingMethods,
    {},
    true,
    'chargingMethodService.GetChargingMethods',
  );

  const values = {
    currencies: currenciesData ?? [],
    currenciesError,
    isLoadingCurrencies,
    countries: countriesData ?? [],
    countriesError,
    isLoadingCountries,
    chargingMethods: chargingMethodsData ?? [],
    chargingMethodsError,
    isLoadingChargingMethod,
  };

  return <FundTransferContext.Provider value={values}>{children}</FundTransferContext.Provider>;
};

export { FundTransferProvider };
